module.exports = __webpack_public_path__ + "static/media/122e775c91b96318a63daf7865786fdc.122e775c.webp";